<template>
  <div>
      <div class="alert alert-secondary service">
        <div class="alert-text">
          Web Application (using wifi dongle - configuration)
        </div>
      </div>

      <div class="row">
        <form-input
          :placeholder="'Wifi Name'"
          :elementID="'Wifiname'"
          :containerClass="'form-group'"
          :inputClass="'form-control-sm'"
          :inputType="'text'"
          :validator="$v.setupData.wifi"
          v-model="setupData.wifi"
        ></form-input>
      </div>
      <div class="row form-group">
        <div class="col-3">
          <label class="input-label">Print Cube Mobile colors</label>
        </div>

        <div class="col-9">
          <div
            :key="`color-${index}`"
            class="input-group"
            v-for="(color, key, index) in setupData.colors"
          >
            <div class="input-group-prepend">
              <span style="color: white;" class="input-group-text" :style="{'background-color': color}">{{key}}</span>
            </div>

            <div class="color" :style="{'background-color': color}"></div>

            <input
              type="text"
              class="form-control"
              :value="color"
              @keyup.stop="$utils.noop"
              @focus="pickerIndex = `picker-${index}`"
            />

            <div class="color-picker" v-if="pickerIndex === `picker-${index}`">
              <div
                class="bg-danger text-white text-center pointer"
                @click="pickerIndex = null"
                key="delete"
              >{{$t('COMMON.close')}}</div>
              <color-picker :value="color" @input="updateColor($event, color, key)" />
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script type="text/babel">
import { mapGetters, mapMutations } from "vuex";

import ColorPicker from "vue-color/src/components/Sketch";
import FormInput from "../../../../Shared/UI/Form/FormInput.vue";
import { required } from "vuelidate/lib/validators";

export default {
  name: "setup-manager",
  data() {
    return {
      pickerIndex: null,
      color: '#ffffff'
    };
  },
  props: {
    data: {
      type: Object,
      default(){
          return {
              colors: {'primary':'#ffffff'}
          };
      }
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    }),
    setupData: {
      get() {
        return this.data;
      },
      set(newValue) {
        this.$emit("update:data", newValue);
      }
    }
  },
  components: {
    FormInput,
    ColorPicker
  },
  validations: {
    setupData: {
      wifi: {
        required
      }
    }
  },
  beforeMount() {
    this.setupData = this.data;
  },
  methods:{
    updateColor(ev, color, key) {
      this.setupData.colors[key] = ev.hex;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
